(function (angular) {
    'use strict';
    //check: para que se muestren o no los checkboxes a la izquierda de cada elemento (para la exportacion)
    angular
        .module('app')
        .component('edicionList', {
            bindings: {
                ediciones: '<',
                check: '<'
            },
            templateUrl: 'app/public/components/listado/edicion.list.html',
            /* @ngInject */
            controller: function () {
                var vm = this;
            },
            controllerAs: 'ctrl'

        });

})(angular);
